module.exports = __webpack_public_path__ + "static/bulette-3fa8557f85df5c9977fbddb90b445842.jpeg";